import domready from 'domready'
import PhotoGalleryController from './controllers/photo-gallery-controller'

export default function initPhotoGallery (breakpoints) {
  domready(() => {
    const element = document.querySelector('.photo-gallery')
    console.log('element', element)
    if (element) {
      // eslint-disable-next-line no-new
      new PhotoGalleryController(element, breakpoints)
    }
  })
}
